export default __webpack_public_path__ + "static/media/File No. 20.acaa68e3.pdf";